import { renderSlot as _renderSlot, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, {
    key: `mobile-menu-wrapper-${$data.componentKey}`,
    to: "#mobile-menu-portal"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}